import React from 'react';
import Layout from '../../shared/components/Layout';
import { Link } from "react-router-dom";

const FlatRateIndex: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <main id="page-facility_login" className="wrapper">
          <section className="sec-contact">
            <div className="inner">
              <h1 className="c-ttl__01">定額制契約</h1>
            </div>
          </section>
          <div className="sec-link">
            <div className="inner">
              <ul className="link-list">
                <li className="link-list__item">
                  <Link to="/facility/flat_rates/registration"> 新規契約申込 </Link>
                </li>
                <li className="link-list__item">
                  <Link to="/facility/flat_rates/customers">お客様情報変更申込</Link>
                </li>
                <li className="link-list__item">
                  <Link to="/facility/flat_rates/terminate_cancels">解約・キャンセル申込</Link>
                </li>
                <li className="link-list__item">
                  <Link to="/facility/flat_rates/lost_non_warranty">紛失・保証外レンズ申込</Link>
                </li>
              </ul>
            </div>
          </div>
        </main>
      </Layout>
    </React.Fragment>
  )
}

export default FlatRateIndex;
